import React, { useState, useEffect } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

const ScrollToTopBottom: React.FC = () => {
  const [showButton, setShowButton] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show button when scrolled more than 300px from top or bottom
      const isNearTop = scrollPosition < 300;
      const isNearBottom = scrollPosition + windowHeight > documentHeight - 300;
      
      setIsAtTop(isNearTop);
      setShowButton(scrollPosition > 300 || !isNearBottom);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  if (!showButton) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={isAtTop ? scrollToBottom : scrollToTop}
        className="p-3 bg-gradient-to-br from-teal-500 via-teal-600 to-teal-700 hover:from-teal-600 hover:via-teal-700 hover:to-teal-800 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 active:scale-95 flex items-center justify-center"
        aria-label={isAtTop ? 'Scroll to bottom' : 'Scroll to top'}
        title={isAtTop ? 'Scroll to bottom' : 'Scroll to top'}
      >
        {isAtTop ? (
          <ChevronDown className="h-6 w-6" />
        ) : (
          <ChevronUp className="h-6 w-6" />
        )}
      </button>
    </div>
  );
};

export default ScrollToTopBottom;

